import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAppIcScreen32 = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	style: { fill: "currentColor" },
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M27 21H5C3.35 21 2 19.65 2 18V7C2 5.35 3.35 4 5 4H27C28.65 4 30 5.35 30 7V18C30 19.65 28.65 21 27 21ZM5 6C4.45 6 4 6.45 4 7V18C4 18.55 4.45 19 5 19H27C27.55 19 28 18.55 28 18V7C28 6.45 27.55 6 27 6H5ZM23 26H9C8.45 26 8 26.45 8 27C8 27.55 8.45 28 9 28H23C23.55 28 24 27.55 24 27C24 26.45 23.55 26 23 26ZM19 21H13V26H19V21Z" })
});
export default SvgAppIcScreen32;
